import Faq from './Faq.vue'

export default Faq
